export const getSelectedOptionValues = (selected) =>
  (Array.isArray(selected) ? selected : selected ? [selected] : [])
    .map((option) => option?.value)
    .filter((value) => value !== null && value !== undefined && value !== "");

export const getSelectedOptionCsv = (selected) =>
  getSelectedOptionValues(selected).join(",");
